module.exports = __webpack_public_path__ + "img/icon-fork.4fa69ff.png";